module.exports = __webpack_public_path__ + "assets/img/discernment_age_scene1.d26f4b79.png";